import React, { PropTypes } from 'react';
import PolicyMain from './policy-main';
import { toLaxTitleCase } from 'titlecase';

const Policies = props => {
  if (!props.locationPolicy) return <span/>;
  const getEditStateInfo = (policyType, label, action) => {
    return {
      type: 'policy',
      title: `${action} ${label} Policy`,
      policyType,
      policiesNotesPage: true,
    };
  };

  const getProps = type => {
    const [info] = props.locationPolicy.filter(policy => policy.policyType === type);
    const titleCase = type === 'freeOfCharge' ? 'Free of Charge' : toLaxTitleCase(type);
    return {
      inMaster: props.inMaster,
      [`${type}Info`]: info,
      deletePolicy: props.deleteLocationPolicy && props.deleteLocationPolicy(type),
      [`add${type === 'freeOfCharge' ? 'FreeOfCharge' : titleCase}`]: () => props.openAddEditContractDialog(getEditStateInfo(type, titleCase, 'Add')),
      [`edit${type === 'freeOfCharge' ? 'FreeOfCharge' : titleCase}`]: () => props.openAddEditContractDialog(getEditStateInfo(type, titleCase, 'Edit')),
      supplierEditable: props.supplierEditable,
      ...(type === 'cancellation' ? { label: 'Cancellation Policy' } : {})
    };
  };
  const policyTypes = [
    'cancellation',
    'child',
    'infant',
    'group',
    'freeOfCharge',
    'family',
  ];
  return (
    <div style={{ marginLeft: '15%', width: '80%', paddingTop: '24px', borderTop: '1px solid #efefef', whiteSpace: 'pre-wrap' }}>
      <div style={{ marginBottom: '12px', fontSize: '16px' }}>POLICIES</div>
      <div style={{ marginLeft: '32px' }}>
        {
          policyTypes.map((type) => (
            <div key={type}>
              <PolicyMain
                policyType={type}
                policyProps={getProps(type)}
              />
              <br/>
            </div>
          ))
        }
      </div>
    </div>
  );
};

Policies.propTypes = {
  openAddEditContractDialog: PropTypes.func,
  supplierEditable: PropTypes.bool,
  locationPolicy: PropTypes.array,
  deleteLocationPolicy: PropTypes.func,
  inMaster: PropTypes.bool,
};

export default Policies;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/policies-node.jsx